import React from 'react';
import MessagingPeopleSkeleton from './MessagingPeopleSkeleton';
import './Messaging.css';

function ThreadSkeleton() {
  return (
    <div className="messaging-thread__skeleton" aria-hidden>
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className={`messaging-thread__skeleton-bubble${i % 2 ? ' is-mine' : ' is-theirs'}`}
        />
      ))}
    </div>
  );
}

/**
 * Full-page messaging layout skeleton for route suspense fallbacks.
 */
export default function MessagingPageSkeleton() {
  return (
    <div className="messaging-page messaging-page--skeleton" aria-busy="true" aria-label="Loading messages">
      <div className="messaging-page__layout">
        <aside className="messaging-people messaging-people--skeleton">
          <div className="messaging-page-skel-block messaging-page-skel-block--title" />
          <div className="messaging-page-skel-block messaging-page-skel-block--search" />
          <div className="messaging-page-skel-tabs">
            <span className="messaging-page-skel-block messaging-page-skel-block--tab" />
            <span className="messaging-page-skel-block messaging-page-skel-block--tab" />
            <span className="messaging-page-skel-block messaging-page-skel-block--tab" />
          </div>
          <MessagingPeopleSkeleton rows={6} />
        </aside>
        <main className="messaging-page__main messaging-page__main--skeleton">
          <div className="messaging-page-skel-block messaging-page-skel-block--thread-header" />
          <ThreadSkeleton />
        </main>
      </div>
    </div>
  );
}
